import * as Yup from "yup";
import { getAge } from "../../../services/stringService";
import moment from "moment";

export const pregnancyValidationFn = (genderFieldName, dobFieldName) => {
    return Yup.object().when([genderFieldName, dobFieldName], {
        is: (gender, dob) => {
            return gender === "Female" && getAge(dob) > 13;
        },
        then: Yup.object().shape({
            isPregnant: Yup.bool()
                .nullable()
                .required("Required"),
            expectedDueDate: Yup.date().when("isPregnant", {
                is: true,
                then: Yup.date()
                    .required("Required")
                    .min(
                        moment()
                            .add(-1, "day")
                            .format(),
                        "Must be future date"
                    )
                    .max(
                        moment()
                            .add(9, "months")
                            .format(),
                        "Cannot be past 9 months"
                    )
                    .typeError("Invalid"),
                otherwise: Yup.date().nullable(),
            }),
            expectedChildren: Yup.number().when("isPregnant", {
                is: true,
                then: Yup.number()
                    .required("Required")
                    .nullable()
                    .positive("Invalid")
                    .integer("Invalid")
                    .typeError("Invalid"),
                otherwise: Yup.number().nullable(),
            }),
        }),
        otherwise: Yup.object()
            .shape({})
            .nullable(),
    });
};
